<template>
  <div id="subject">
    <!-- begin page-header -->
    <h1 class="page-header">Aktivasi Organisasi</h1>
    <!-- end page-header -->

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="widget widget-stats bg-blue">
          <div class="stats-info">
            <p>Bulk Activation / Registration Upload .CSV</p>
          </div>
          <div class="stats-link">
            <a href="#">Upload <i class="fa fa-arrow-circle-o-right"></i></a>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="widget widget-stats bg-blue">
          <div class="stats-info">
            <p>Download Example csv</p>
          </div>
          <div class="stats-link">
            <a :href="ossTemplate" download>
              Download <i class="fa fa-arrow-circle-o-right"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ossTemplate:process.env.OSS_TEMPLATE,
    }
  },
}
</script>


// WEBPACK FOOTER //
// OrganizationsActivation.vue?501014c5